import * as React from "react";
import Box from "@mui/material/Box";

const DEFAULT_STEPS = [
    "Category",
    "Template Name",
    "Language",
    "Header",
    "Body",
    "Footer",
    "Buttons",
];

export const AUTH_TEMPLATE_STEPS = [
    "Category",
    "Template Name",
    "Language",
    "OTP Message",
    "Code Expiration",
    "OTP Button",
];

export default function TemplateCreationSteppers({ currentStep, steps = DEFAULT_STEPS, accent = "#111827" }) {
    return (
        <Box
            sx={{
                width: "100%",
                px: { xs: 0.5, sm: 1 },
                py: 1.5,
                borderRadius: 2,
                border: "1px solid rgba(0,0,0,0.08)",
                backgroundColor: "#fff",
                overflowX: "auto",
            }}
        >
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${steps.length}, minmax(104px, 1fr))`,
                    minWidth: steps.length * 104,
                    columnGap: 1,
                    alignItems: "start",
                }}
            >
                {steps.map((label, index) => {
                    const active = index === currentStep;
                    const done = index < currentStep;
                    return (
                        <Box
                            key={label}
                            sx={{
                                minWidth: 0,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 0.75,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 28,
                                    height: 28,
                                    borderRadius: "50%",
                                    display: "grid",
                                    placeItems: "center",
                                    flexShrink: 0,
                                    fontSize: "0.8rem",
                                    fontWeight: 700,
                                    color: "#fff",
                                    backgroundColor: active || done ? accent : "rgba(0,0,0,0.18)",
                                }}
                            >
                                {index + 1}
                            </Box>
                            <Box
                                component="span"
                                sx={{
                                    display: "block",
                                    width: "100%",
                                    textAlign: "center",
                                    fontSize: "0.75rem",
                                    fontWeight: active || done ? 700 : 600,
                                    lineHeight: 1.3,
                                    color: active || done ? "text.primary" : "text.secondary",
                                    overflowWrap: "anywhere",
                                }}
                            >
                                {label}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
